import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-[#1A4D2E] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center">
                <span className="text-[#1A4D2E] font-bold text-xl">H</span>
              </div>
              <span className="font-bold text-xl">Hometown Help</span>
            </div>
            <p className="text-white/70 max-w-md mb-6">
              The trusted platform for contractors and property managers to build 
              and manage their subcontractor network across 20+ trade categories.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="mailto:hello@hometownhelp.local"
                className="flex items-center gap-2 text-white/70 hover:text-white transition-colors"
              >
                <Mail className="w-5 h-5" />
                <span>hello@hometownhelp.local</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Popular Trades</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/directory?category=cat_plumbing" className="text-white/70 hover:text-white transition-colors">
                Plumbing
              </Link>
              <Link to="/directory?category=cat_electrical" className="text-white/70 hover:text-white transition-colors">
                Electrical
              </Link>
              <Link to="/directory?category=cat_hvac" className="text-white/70 hover:text-white transition-colors">
                HVAC
              </Link>
              <Link to="/directory?category=cat_roofing" className="text-white/70 hover:text-white transition-colors">
                Roofing
              </Link>
            </nav>
          </div>

          {/* For Subcontractors */}
          <div>
            <h4 className="font-semibold text-lg mb-4">For Subcontractors</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/create-listing" className="text-white/70 hover:text-white transition-colors">
                List Your Trade
              </Link>
              <Link to="/provider" className="text-white/70 hover:text-white transition-colors">
                Provider Dashboard
              </Link>
              <Link to="/directory" className="text-white/70 hover:text-white transition-colors">
                Browse All Trades
              </Link>
              <Link to="/admin-setup" className="text-white/50 hover:text-white transition-colors text-sm mt-2">
                Admin Login
              </Link>
            </nav>
          </div>
        </div>

        <div className="border-t border-white/20 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} Hometown Help. Built for contractors.
          </p>
          <div className="flex items-center gap-2 text-white/50 text-sm">
            <MapPin className="w-4 h-4" />
            <span>Your trusted subcontractor network</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
